import { usePriceAndFitmentContext } from '../../../contexts/price-and-fitment-context/price-and-fitment-context';
import { PCC_SEARCH_RESULTS } from '../constants/analytics-constants';
import { transformProductPriceData } from '../utils/utils';

interface UseProductPriceDataProps {
  products: Product[];
  serialNumber: string;
  productNumber: string;
  index: number;
  ecommerceListNameAndId?: string;
}
export const useProductPriceData = ({
  products,
  serialNumber,
  productNumber,
  index,
  ecommerceListNameAndId = PCC_SEARCH_RESULTS
}: UseProductPriceDataProps) => {
  const { priceAndAvailability, fitmentResponse } = usePriceAndFitmentContext();
  const productsWithPriceData = transformProductPriceData(
    products,
    priceAndAvailability,
    serialNumber,
    fitmentResponse,
    ecommerceListNameAndId,
    true
  );
  const fitmentCheck = fitmentResponse?.[productNumber]?.isSerialCompatible
    ? 'fity'
    : 'fitn';

  const findProduct = (partNumber: string) =>
    productsWithPriceData?.find((data) => data.partNumber === partNumber);

  const productPriceData = {
    ...findProduct(productNumber),
    index
  };
  const categoryPath = productPriceData.categoryPathList?.[0]?.replace(
    /:/g,
    '/'
  );

  return {
    productPriceData: {
      ...productPriceData,
      categoryPath
    },
    fitmentCheck
  };
};
